import {useAlert} from "../../utils/context/alert-context";
import {getStatisticsApi} from "./statistics.service";
import {useEffect, useState} from "react";
import {EltrpModal} from "../../components/ui/modal/eltrp-modal";
import Grid2 from "@mui/material/Unstable_Grid2";
import {Box, Button, Divider, MenuItem, Select} from "@mui/material";

const prettyName = (fileName:string) => {
    const match = fileName.match("[0-9]{4}-[0-9]{2}-[0-9]{2}");
    if (match !== null) {
        return match[0]
    }
    else return fileName;
}

interface StatisticsBoxProps {
    open:boolean;
    setOpen: (val: boolean) => void;
}

export const StatisticsBox = ({open, setOpen}:StatisticsBoxProps) => {
    const alert = useAlert();

    const [articleViewsWeeklyFiles, setArticleViewsWeeklyFiles] = useState<string[]>([]);
    const [selectedArticleViewsWeeklyFile, setSelectedArticleViewsWeeklyFile] = useState<string>("")

    useEffect(() => {
        if(open) {
            getStatisticsApi("article-views-weekly", alert.handleAlert).subscribe((res) => {
                setArticleViewsWeeklyFiles(res)
            });
        }
    }, [open, alert.handleAlert]);

    const downloadFile = (file: string) => {
        window.open("/api/v1/storage/stats/download/" + encodeURIComponent(file), "_blank");
    }


    return (
        <EltrpModal
            title={"Statistics"}
            open={open}
            handleClose={() => setOpen(false)}
        >
            <Grid2 container gap={1} textAlign={"center"}>
                <Grid2>
                    Download usage statistics files for ELTRP. <br />
                </Grid2>
                <Grid2 xs={12} p={1}>
                    <Divider>
                        {" "}
                        <b> Article views per week</b>
                    </Divider>
                    <Box display={"flex"} justifyContent={"center"} gap={"1rem"} mt={"1rem"} mb={"1rem"}>
                        <Select
                            value={selectedArticleViewsWeeklyFile}
                            onChange={e => setSelectedArticleViewsWeeklyFile(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>Pick a date</em>
                            </MenuItem>
                            {articleViewsWeeklyFiles.map( f => (
                                <MenuItem key={f} value={f}>{prettyName(f)}</MenuItem>
                                ))
                            }
                        </Select>
                        <Button color={"secondary"} variant={"contained"} onClick={() => downloadFile(selectedArticleViewsWeeklyFile)} disabled={!selectedArticleViewsWeeklyFile}>Download</Button>
                    </Box>
                    <Divider>
                        {" "}
                        <b> Weekly visitors </b>
                    </Divider>
                    <Box mt={"1rem"} mb={"1rem"}>
                        <Button color={"secondary"} variant={"contained"} onClick={() => downloadFile("visitors-weekly.csv")}>Download</Button>
                    </Box>
                </Grid2>
            </Grid2>
        </EltrpModal>
    )

}
